import {useCallback} from "react";
import {VisuallyHidden} from "@mantine/core";
import classes from "./form-elements.module.css";

interface CheckboxProps {
    checked: boolean;
    onChange?: () => void;
    onBlur?: (e: any) => void;
    onFocus?: (e: any) => void;
    id?: string;
    className?: string;
    tabIndex?: number;
}

export const Checkbox = ({
    checked,
    onChange,
    onBlur,
    onFocus,
    id,
    className,
    tabIndex = 0,
}: CheckboxProps) => {
    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange?.();
            }
        },
        [onChange]
    );

    return (
        <div
            className={`${classes.checkbox}${className ? ` ${className}` : ""}`}
        >
            <span
                className={`${classes.visualCheckbox}${checked ? ` ${classes.checked}` : ""}`}
                tabIndex={tabIndex}
                role="checkbox"
                aria-checked={checked}
                onKeyDown={handleKeyDown}
            >
                <svg
                    className={classes.checkboxSvg}
                    viewBox="0 0 40 40"
                    aria-hidden="true"
                >
                    <polyline
                        points="9.1,22.3 15.7,28.8 31.4,13"
                        className={`${classes.checkmark}${checked ? ` ${classes.checked}` : ""}`}
                    />
                </svg>
            </span>
            <VisuallyHidden>
                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    tabIndex={-1}
                    readOnly={!onChange}
                />
            </VisuallyHidden>
        </div>
    );
};
